
import React from 'react';
import { Card } from "@/components/ui/card";
import { Match } from '../types/head-to-head';

interface MatchDetailsCardProps {
  match: Match;
}

export const MatchDetailsCard: React.FC<MatchDetailsCardProps> = ({ match }) => {
  return (
    <Card className="p-4">
      <div className="space-y-4">
        <div className="flex justify-between items-center border-b pb-2">
          <span className="text-sm text-gray-600">{match.Date}</span>
          <span className="text-sm font-medium">
            {match.HomeTeam} vs {match.AwayTeam}
          </span>
        </div>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <h4 className="text-sm font-medium mb-2">Match Stats</h4>
            <div className="text-sm space-y-1">
              <p>Full Time: {match.FTHG} - {match.FTAG}</p>
              <p>Half Time: {match.HTHG} - {match.HTAG}</p>
              <p>Corners: {match.HC} - {match.AC}</p>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-medium mb-2">Additional Info</h4>
            <div className="text-sm space-y-1">
              <p>Shots: {match.HS} - {match.AS}</p>
              <p>Shots on Target: {match.HST} - {match.AST}</p>
              <p>Fouls: {match.HF} - {match.AF}</p>
              <p>Cards: 🟨 {match.HY}-{match.AY} 🟥 {match.HR}-{match.AR}</p>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default MatchDetailsCard;
